export default "__VITE_ASSET__DO5wdO1Z__"